export default "__VITE_ASSET__BXO44TVh__"